import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import SelectField from '../global/fields/SelectField';
import { apiUrl } from '../../constants/apiConsts';
import { getHeaders } from '../../api/helpers';

function UpdateReligion({ fk, hide, value, updateFieldData }) {
  const [closeModal, updateCloseModal] = useState(true);
  const [religionList, setReligionList] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    async function fetchReligionList() {
      try {
        const request = new Request(`${apiUrl}/content/religion_list`, {
          method: 'GET',
          headers: getHeaders(),
        });

        const response = await fetch(request);
        const data = await response.json();

        const list = data.religionList.map((item) => {
          return {
            displayName: item.name,
            value: item.id,
            label: item.name,
            displayName: item.name,
          }
        })

          setReligionList(list);
          setIsLoading(false);

        if (!response.ok) {
          setIsLoading(false);
          throw new Error(`HTTP error! status: ${response.status}`);
        }
      } catch (error) {
        setIsLoading(false);
        console.error('Failed to fetch gender list:', error);
      }
    }
    fetchReligionList();
  }, []);

  if (isLoading) return null;

  return (
    <div className="modal-content update_nationality">
      <div className="modal-header bg-white">
        <h5 className="modal-title">Religion</h5>
      </div>
      <div className="modal-body">
        <SelectField
          placeholder={'Select Religion'}
          options={religionList}
          key={fk}
          fk={fk}
          value={value}
          updateFieldData={(fk, values, error) => {
            const religion = religionList.filter((item) => item.value === values);
            const displayName = religion.length ? religion[0].displayName : '';

            updateFieldData(fk, values, error, displayName);
            if (!closeModal) {
              hide();
            }

            if (closeModal) updateCloseModal(false);
          }}
        />
      </div>
      <div className="modal-footer mt-3">
        <button
          type="button"
          disabled={false}
          className={`button update_nationality__button`}
          onClick={hide}
        >
          Cancel
        </button>
      </div>
    </div>
  );
}

UpdateReligion.propTypes = {
  hide: PropTypes.func.isRequired,
  value: PropTypes.number.isRequired,
  updateValue: PropTypes.func.isRequired,
};

export default UpdateReligion;
